"use strict";
// https://github.com/ethereum/ercs/blob/master/ERCS/erc-1155.md#metadata
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=meta-data.js.map